import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { I18nextProvider } from 'react-i18next';

import i18n from './_app/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as stores from './stores';
import 'react-toastify/dist/ReactToastify.min.css';

ReactDOM.render(
  <Provider {...stores}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
